import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'

import FirebaseService from '@/services/FirebaseService.js'

import Content from '@/components/Content.vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAt,
  faCalendarAlt,
  faCheck,
  faCloudUploadAlt,
  faCommentDots,
  faCookieBite,
  faCreditCard,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faHandPointLeft,
  faInfo,
  faPlus,
  faSave,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons'

import { faCauldron, faUtensilsAlt } from '@fortawesome/pro-solid-svg-icons'

import { faBirthdayCake, faHamburger } from '@fortawesome/pro-regular-svg-icons'

import {
  faFacebookSquare,
  faInstagram
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAt,
  faBirthdayCake,
  faCalendarAlt,
  faCauldron,
  faCheck,
  faCloudUploadAlt,
  faCommentDots,
  faCookieBite,
  faCreditCard,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faFacebookSquare,
  faHamburger,
  faHandPointLeft,
  faInfo,
  faInstagram,
  faPlus,
  faSave,
  faTrashAlt,
  faUtensilsAlt
)

Vue.use(VueCookies)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Content', Content)

Vue.prototype.$database = FirebaseService.database()
Vue.prototype.$storage = FirebaseService.storage()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
